import React from 'react';

import { FormControl } from '@mui/material';
import { Controller } from 'react-hook-form';

import { getFieldErrorMessage, useFormContext } from '../FormProvider';
import { Upload } from './Request/upload';

type Props = {
  name: string;
  url: string;
  fileTypes: string[];
  sizeView: 'kb' | 'mb';
  maxFileSizeMb?: number;
  uploadedFileName?: string | string[];
  dropHereOr?: string;
  placeholder?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  multiple?: boolean;
  margin?: 'none' | 'dense' | 'normal';
  onUpload?: (fieldName: string, fileName: string) => void;
  onUploadMultiple?: (fieldName: string, fileNames: string[]) => void;
  onRemove: (fileName: string) => void;
};

const DEFAULT_MAX_FILE_SIZE_MB = 5;

export const ControlledFileField: React.FC<Props> = ({
  name,
  url,
  fileTypes,
  sizeView = 'kb',
  maxFileSizeMb,
  uploadedFileName,
  dropHereOr,
  placeholder,
  disabled,
  onRemove,
  onUpload,
  onUploadMultiple,
  multiple = false,
  fullWidth = true,
  margin = 'normal',
}) => {
  const { control, errors } = useFormContext();
  const maxFileSize = maxFileSizeMb ?? DEFAULT_MAX_FILE_SIZE_MB;
  const fileTypesLabel = fileTypes.join(', ');

  const styles = {
    fontSize: '14px',
    fontWeight: 600,
    color: '#9598a7',
    marginBottom: '5px',
  };

  return (
    <FormControl fullWidth={fullWidth} margin={margin}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            {placeholder && <div style={styles}>{placeholder}</div>}
            <div style={{ color: '#9598a7', fontSize: '12px', marginBottom: '8px' }}>
              Разрешенные форматы: {fileTypesLabel}. Максимальный размер: {maxFileSize} Мб.
            </div>
            <Upload
              url={url}
              fileTypes={fileTypes}
              sizeView={sizeView}
              maxFileSizeMb={maxFileSizeMb}
              uploadedFileName={uploadedFileName}
              dropHereOr={dropHereOr}
              multiple={multiple}
              disabled={disabled}
              fieldName={field.name}
              onRemove={onRemove}
              onUploaded={(fieldName, fileNames) => {
                if (Array.isArray(fileNames)) {
                  onUploadMultiple?.(fieldName, fileNames);
                } else {
                  onUpload?.(fieldName, fileNames);
                }
              }}
            />
            {!!errors?.[name] && (
              <span style={{ color: 'red', fontSize: '12px' }}>{getFieldErrorMessage(errors?.[name])}</span>
            )}
          </>
        )}
      />
    </FormControl>
  );
};
